var _defs, _rect, _rect2, _circle, _text, _text2, _rect3, _circle2, _text3, _rect4, _circle3, _text4, _text5, _rect5, _circle4, _text6, _text7, _rect6, _circle5, _text8, _text9, _rect7, _text0, _text1, _text10, _text11, _path, _circle6, _circle7, _rect8, _text12, _text13, _path2, _rect9, _text14, _text15, _circle8, _circle9, _rect0, _text16, _text17, _path3, _rect1, _text18, _text19, _circle0, _circle1, _rect10, _text20, _text21, _path4, _rect11, _text22, _text23, _circle10, _circle11, _rect12, _text24, _text25, _path5, _rect13, _text26, _text27, _rect14, _circle12, _path6, _text28, _text29, _rect15, _text30, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportRenewalSchedulerTrainingCohortTimelineDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1400,
    height: 780,
    viewBox: "0 0 1400 780",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport intelligent renewal and training scheduler") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-rs-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wp-rs-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 16,
    stdDeviation: 24,
    floodColor: "#020716",
    floodOpacity: 0.16
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 1360,
    height: 740,
    rx: 38,
    fill: "url(#wp-rs-bg)",
    stroke: "#29405D",
    filter: "url(#wp-rs-shadow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 1300,
    height: 84,
    rx: 20,
    fill: "#07152A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 92,
    r: 8,
    fill: "#30D6A1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 84,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "RENEWAL INTELLIGENCE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 112,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "First Aid renewal cohort")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1168,
    y: 72,
    width: 154,
    height: 42,
    rx: 12,
    fill: "#E7F8F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1192,
    cy: 93,
    r: 6,
    fill: "#30D6A1"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 99,
    fill: "#08755A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850
  }, "PROPOSED")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 158,
    width: 226,
    height: 122,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 188,
    r: 6,
    fill: "#087CFF"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 236,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 40,
    fontWeight: 880
  }, "14")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 262,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 820,
    letterSpacing: 1
  }, "EMPLOYEES")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 158,
    width: 226,
    height: 122,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 327,
    cy: 188,
    r: 6,
    fill: "#FF2775"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 324,
    y: 236,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 40,
    fontWeight: 880
  }, "3")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 324,
    y: 262,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 820,
    letterSpacing: 1
  }, "ACTIVE SITES")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 158,
    width: 226,
    height: 122,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 577,
    cy: 188,
    r: 6,
    fill: "#30D6A1"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 574,
    y: 236,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 40,
    fontWeight: 880
  }, "8h")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 574,
    y: 262,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 820,
    letterSpacing: 1
  }, "GROUP DOWNTIME")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 158,
    width: 550,
    height: 122,
    rx: 20,
    fill: "#07152A"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 194,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "PROPOSED TRAINING GROUP")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 231,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 850
  }, "14 employees across 3 sites")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 258,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 680
  }, "One coordinated session \xB7 Lowest predicted disruption")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 330,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "COMPLETION WINDOWS")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 454H1250",
    stroke: "#BFD8EE",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 454,
    r: 21,
    fill: "#FFFFFF",
    stroke: "#087CFF",
    strokeWidth: 6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 454,
    r: 7,
    fill: "#087CFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 372,
    width: 256,
    height: 64,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 397,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.1
  }, "MAY \xB7 OPTIONAL WINDOW")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 420,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Choose an early session")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 436v-18",
    stroke: "#087CFF",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 488,
    width: 256,
    height: 96,
    rx: 18,
    fill: "#087CFF",
    fillOpacity: 0.09,
    stroke: "#087CFF",
    strokeOpacity: 0.35
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 520,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "EMPLOYEE CHOICE")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 548,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 720,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 108,
    dy: 0
  }, "Select from early"), /*#__PURE__*/React.createElement("tspan", {
    x: 108,
    dy: 20
  }, "available dates"))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 454,
    r: 21,
    fill: "#FFFFFF",
    stroke: "#30D6A1",
    strokeWidth: 6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 454,
    r: 7,
    fill: "#30D6A1"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 372,
    width: 256,
    height: 64,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 438,
    y: 397,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.1
  }, "JUNE \xB7 RECOMMENDED")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 438,
    y: 420,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Complete with the cohort")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M480 436v-18",
    stroke: "#30D6A1",
    strokeWidth: 3
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 488,
    width: 256,
    height: 96,
    rx: 18,
    fill: "#30D6A1",
    fillOpacity: 0.09,
    stroke: "#30D6A1",
    strokeOpacity: 0.35
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 438,
    y: 520,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "BEST COHORT FIT")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 438,
    y: 548,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 720,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 438,
    dy: 0
  }, "Recommended group"), /*#__PURE__*/React.createElement("tspan", {
    x: 438,
    dy: 20
  }, "completion"))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 454,
    r: 21,
    fill: "#FFFFFF",
    stroke: "#F5B642",
    strokeWidth: 6
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 454,
    r: 7,
    fill: "#F5B642"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 746,
    y: 372,
    width: 256,
    height: 64,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 397,
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.1
  }, "JULY \xB7 FINAL WINDOW")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 420,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Escalation begins")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M810 436v-18",
    stroke: "#F5B642",
    strokeWidth: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 746,
    y: 488,
    width: 256,
    height: 96,
    rx: 18,
    fill: "#F5B642",
    fillOpacity: 0.09,
    stroke: "#F5B642",
    strokeOpacity: 0.35
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 520,
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "MANAGER ESCALATION")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 548,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 720,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 768,
    dy: 0
  }, "Final available"), /*#__PURE__*/React.createElement("tspan", {
    x: 768,
    dy: 20
  }, "completion window"))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1140,
    cy: 454,
    r: 21,
    fill: "#FFFFFF",
    stroke: "#FF6B67",
    strokeWidth: 6
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1140,
    cy: 454,
    r: 7,
    fill: "#FF6B67"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1076,
    y: 372,
    width: 256,
    height: 64,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 1098,
    y: 397,
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.1
  }, "AUGUST \xB7 EXPIRY")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 1098,
    y: 420,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Deployment at risk")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1140 436v-18",
    stroke: "#FF6B67",
    strokeWidth: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1076,
    y: 488,
    width: 256,
    height: 96,
    rx: 18,
    fill: "#FF6B67",
    fillOpacity: 0.09,
    stroke: "#FF6B67",
    strokeOpacity: 0.35
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 1098,
    y: 520,
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "READINESS AT RISK")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 1098,
    y: 548,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 720,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1098,
    dy: 0
  }, "Programme expires"), /*#__PURE__*/React.createElement("tspan", {
    x: 1098,
    dy: 20
  }, "if unresolved"))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 628,
    width: 1300,
    height: 88,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 672,
    r: 25,
    fill: "#E7F8F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78 684l7-7 7 5 14-18M99 664h7v7",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 132,
    y: 661,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 850
  }, "Recommended action")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 132,
    y: 689,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 680
  }, "Schedule one June First Aid session for the proposed 14-person cohort.")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1094,
    y: 649,
    width: 226,
    height: 46,
    rx: 13,
    fill: "#087CFF"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 1118,
    y: 678,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850
  }, "Review cohort")), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1278 672h14m-6-6 6 6-6 6",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportRenewalSchedulerTrainingCohortTimelineDesktop);
export default __webpack_public_path__ + "static/media/work-passport-renewal-scheduler-training-cohort-timeline-desktop.bf4371b78a1d4121ecf58eb284ed8dbd.svg";
export { ForwardRef as ReactComponent };